import { MAX_PAGE_INDEX } from "./providerSearchRules";

const button = (enabled) => ({
  padding: "5px 12px", borderRadius: 6, fontSize: 12, fontWeight: 600, fontFamily: "inherit",
  border: "1px solid #e5e7eb", background: enabled ? "white" : "#f3f4f6",
  color: enabled ? "#0B2545" : "#9ca3af", cursor: enabled ? "pointer" : "not-allowed",
});

/**
 * "Showing 26-50 of 9,940   Prev  Page 2 of 398  Next". pageInfo is { page, size, total, totalPages } as sent
 * by the server; page numbers start at 0. onPage(n) asks for page n.
 */
export default function ProviderPager({ pageInfo, disabled, onPage }) {
  const { page, size, total, totalPages } = pageInfo;
  const lastPage = Math.min(totalPages - 1, MAX_PAGE_INDEX);
  const from = total === 0 ? 0 : page * size + 1;
  const to = Math.min(total, (page + 1) * size);
  const canPrev = !disabled && page > 0;
  const canNext = !disabled && page < lastPage;
  const capped = totalPages - 1 > MAX_PAGE_INDEX;

  return (
    <div style={{ padding: "10px 20px", background: "#f9fafb", borderBottom: "1px solid #f3f4f6", fontSize: 12, color: "#374151" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
        <span>
          Showing <strong>{from.toLocaleString()}-{to.toLocaleString()}</strong> of <strong>{total.toLocaleString()}</strong>
        </span>
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button type="button" disabled={!canPrev} onClick={() => onPage(page - 1)} style={button(canPrev)}>Prev</button>
          <span>Page {page + 1} of {totalPages.toLocaleString()}</span>
          <button type="button" disabled={!canNext} onClick={() => onPage(page + 1)} style={button(canNext)}>Next</button>
        </span>
      </div>
      {capped && (
        <div style={{ marginTop: 6, color: "#b45309" }}>
          Only the first {((MAX_PAGE_INDEX + 1) * size).toLocaleString()} results can be paged through. Add a filter to narrow the search.
        </div>
      )}
    </div>
  );
}
